import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-upload-req-step-recruiters',
  templateUrl: './upload-req-step-recruiters.component.html'
})
export class UploadReqStepRecruitersComponent implements OnChanges {

  @Input() job: any = {};
  @Input() currentJobStatus;
  @Input() userDetails;
  @Input() editTitleFlag;
  @Input() editBUFlag;
  @Input() clientOrBUIsRequiredFlag;
  @Input() clientOrBuLabel;
  @Input() clientorbulist: any[] = [];
  @Input() isLoadingSharedClientBus;
  @Input() sharedClientBus: any[] = [];
  @Input() sharedClientBuOrCorp: any;
  @Input() jobTypeList: any[] = [];
  @Input() selectedJobTypes: any[] = [];
  @Input() contractDurations: any[] = [];
  @Input() workLocationsList: any[] = [];
  @Input() selectedWorkLocationsList: any[] = [];
  @Input() salaryLabel;
  @Input() currencyCodes: any[] = [];
  @Input() salaryDurationOptions: any[] = [];
  @Input() sponsorshipList: any[] = [];
  @Input() recruiterList: any[] = [];
  @Input() selectedRecruiters: any[] = [];
  @Input() isCorporate;
  @Input() hiringManagerList: any[] = [];
  @Input() selectedHiringManagers: any[] = [];
  @Input() primaryHiringManagerList: any[] = [];
  @Input() primaryHiringManagerId;
  @Input() pocs: any[] = [];
  @Input() selectedPocs: any[] = [];
  @Input() vendorsList: any[] = [];
  @Input() selectedVendors: any[] = [];
  @Input() sharedJobPocs: any[] = [];
  @Input() showEndClientSection;
  @Input() endClient: any[] = null;
  @Input() endClientSearchResults: any[] = [];
  @Input() isLoadingEndClientSearch;
  @Input() isManageEndClient;
  @Input() formalizeActivityPayload;
  @Input() step2Error: any = {};
  @Input() step2Submitted;

  @Output() editTitleToggleCallback = new EventEmitter<void>();
  @Output() editBUToggleCallback = new EventEmitter<void>();
  @Output() jobTitleChangeCallback = new EventEmitter<void>();
  @Output() clientOrBuChangeCallback = new EventEmitter<void>();
  @Output() sharedClientBuOrCorpChangeCallback = new EventEmitter<any>();
  @Output() updateLocationCallback = new EventEmitter<void>();
  @Output() showJobProfileCallback = new EventEmitter<void>();
  @Output() requisitionNumberChangeCallback = new EventEmitter<void>();
  @Output() openingsChangeCallback = new EventEmitter<void>();
  @Output() jobTypeSelectedCallback = new EventEmitter<any>();
  @Output() workLocationsSelectedCallback = new EventEmitter<any[]>();
  @Output() salaryTypeChangeCallback = new EventEmitter<string>();
  @Output() sponsorshipProvidedSelectedCallback = new EventEmitter<void>();
  @Output() sponsorshipSelectedCallback = new EventEmitter<{ index: number, sponsorship: any }>();
  @Output() recruitersSelectedCallback = new EventEmitter<any[]>();
  @Output() hiringManagersSelectedCallback = new EventEmitter<any[]>();
  @Output() primaryHiringManagerSelectedCallback = new EventEmitter<any>();
  @Output() vendorsSelectedCallback = new EventEmitter<any[]>();
  @Output() pocSelectedCallback = new EventEmitter<any[]>();
  @Output() endClientSearchCallback = new EventEmitter<string>();
  @Output() endClientChangeCallback = new EventEmitter<any[]>();
  @Output() addEditEndClientCallback = new EventEmitter<string>();
  @Output() voiceTranscriptCallback = new EventEmitter<string>();
  @Output() receiveFormalizedCommentCallback = new EventEmitter<string>();
  @Output() requiredFieldsValidChange = new EventEmitter<boolean>();

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  jobTypeSelection: any = null;
  pocSelection: any = null;
  endClientSelection: any = null;

  ngOnChanges() {
    this.jobTypeSelection = (this.selectedJobTypes && this.selectedJobTypes.length > 0) ? this.selectedJobTypes[0] : null;
    this.pocSelection = (this.selectedPocs && this.selectedPocs.length > 0) ? this.selectedPocs[0] : null;
    this.endClientSelection = (this.endClient && this.endClient.length > 0) ? this.endClient[0] : null;
    this.requiredFieldsValidChange.emit(this._areRequiredFieldsValid());
  }

  private _areRequiredFieldsValid(): boolean {
    const job = this.job || {};
    const jobSalary = job.jobSalary || {};

    const titleValid = !this.editTitleFlag || !!(job.title && job.title !== '');
    const clientValid = !this.editBUFlag || !this.clientOrBUIsRequiredFlag ||
      !!(job.clientorbu && job.clientorbu.id);
    const sharedClientBuVisible = this.userDetails && this.userDetails.company &&
      this.userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.STAFFING &&
      (job.isSharedClientRequisition || (job.sharedClientBuOrCorpId !== null && job.sharedClientBuOrCorpId !== undefined)) &&
      !this.isLoadingSharedClientBus;
    const sharedClientBuValid = !sharedClientBuVisible || !!(this.sharedClientBuOrCorp && this.sharedClientBuOrCorp.id);
    const requisitionNumberValid = !!(job.requisitionNumber && job.requisitionNumber !== '');
    const openingsValid = job.openings !== null && job.openings !== undefined && job.openings >= 1;
    const isContractJobType = job.jobType === 'CONTRACTTOHIRE' || job.jobType === 'CONTRACTOR';
    const contractDurationValid = !isContractJobType || !!job.contractDuration;

    const salaryType = jobSalary.salaryType;
    const amountValid = salaryType !== 'SPECIFIC' || !!jobSalary.maxSalary;
    const currencyValid = (salaryType !== 'SPECIFIC' && salaryType !== 'RANGE') || !!jobSalary.currency;
    const salaryDurationValid = (salaryType !== 'SPECIFIC' && salaryType !== 'RANGE') || !!jobSalary.salaryDuration;
    const rangeValid = salaryType !== 'RANGE' || !!(jobSalary.minSalary && jobSalary.maxSalary);

    return titleValid && clientValid && sharedClientBuValid && requisitionNumberValid && openingsValid &&
      contractDurationValid && amountValid && currencyValid && salaryDurationValid && rangeValid;
  }

  trackById(index: number, item: any) {
    return item && item.id;
  }

  onJobTitleChange() {
    this.jobTitleChangeCallback.emit();
  }

  onClientOrBuIdChange(id: any) {
    if (!this.job.clientorbu) {
      this.job.clientorbu = {};
    }
    this.job.clientorbu.id = id;
    this.clientOrBuChangeCallback.emit();
  }

  onSharedClientBuOrCorpChange(id: any) {
    const bu = (this.sharedClientBus || []).find((b) => String(b.id) === String(id));
    this.sharedClientBuOrCorpChangeCallback.emit(bu);
  }

  onJobTypeChange(items: any[]) {
    this.jobTypeSelectedCallback.emit(items);
  }

  onWorkLocationsChange(items: any[]) {
    this.workLocationsSelectedCallback.emit(items);
  }

  onSponsorshipToggle(index: number, sponsorship: any) {
    sponsorship.selected = !sponsorship.selected;
    this.sponsorshipSelectedCallback.emit({ index, sponsorship });
  }

  onRecruitersChange(items: any[]) {
    this.recruitersSelectedCallback.emit(items);
  }

  onHiringManagersChange(items: any[]) {
    this.hiringManagersSelectedCallback.emit(items);
  }

  onPocChange(items: any[]) {
    this.pocSelectedCallback.emit(items);
  }

  onVendorsChange(items: any[]) {
    this.vendorsSelectedCallback.emit(items);
  }

  onEndClientSearch(event: any) {
    this.endClientSearchCallback.emit(event ? event.term : '');
  }

  onEndClientChange(items: any[]) {
    this.endClientChangeCallback.emit(items);
  }

  getMultiSelectSummary(items: any[], bindLabel: string): string {
    if (!items || items.length === 0) { return ''; }
    const firstLabel = items[0][bindLabel];
    return items.length > 1 ? `${firstLabel} ... (${items.length})` : firstLabel;
  }

  selectRemoveAll(list: string, type: string): void {
    const selectAll = type === 'selectAll';
    switch (list) {
      case 'workLocations':
        this.selectedWorkLocationsList = selectAll ? [...this.workLocationsList] : [];
        this.onWorkLocationsChange(this.selectedWorkLocationsList);
        break;
      case 'recruiters':
        this.selectedRecruiters = selectAll ? [...this.recruiterList] : [];
        this.onRecruitersChange(this.selectedRecruiters);
        break;
      case 'hiringManagers':
        this.selectedHiringManagers = selectAll ? [...this.hiringManagerList] : [];
        this.onHiringManagersChange(this.selectedHiringManagers);
        break;
      case 'vendors':
        this.selectedVendors = selectAll ? [...this.vendorsList] : [];
        this.onVendorsChange(this.selectedVendors);
        break;
    }
  }
}
